import React from "react";
import useAlert from "../../../hooks/useAlert";
import { Error, ErrorClose } from "../../atoms/Error";
import HighlightTextWithLogic from "../../molecule/HighlightTextWithLogic";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const styles = {
  hightlightMessage: {
    color: "white",
    fontSize: "14px",
    fontFamily: "Lato",
    marginTop: "15px",
  },
  textMessage: {
    color: "white",
    fontSize: "14px",
    fontFamily: "Lato",
    marginTop: "5px",
  },
  textMessageUnderline: {
    color: "white",
    fontSize: "14px",
    fontFamily: "Lato",
    marginTop: "5px",
    marginLeft:"5px",
    textDecorationLine: "underline",
  },
  retryTouchableOpacityContainer: {
    height: "30px",
    width: "100%",
    marginTop: "10px",
  },
  retryNo: {
    height: "30px",
    width: "100%",
    marginTop: "10px",
    marginLeft: "20px",
  },
  retryContainer: {
    flexDirection: "row",
    flex: 1,
  },
  optionCointainer:{
    display:"flex",
    flexDirection: "row",
    width: "fit-content",
  }
}

const TextLink = styled.a`
    cursor: pointer;
    font-style: normal;
`

const AlertPopup = () => {
  const { t } = useTranslation();
  const { title, text, desc, searchWords, type="error", destroyAlert,yesButton, noButton , isRetryEnabled, buttonClicked} = useAlert();
 
  const handleClick=(e)=>{
    e.preventDefault();
    if(isRetryEnabled && buttonClicked){
      buttonClicked(3);
    }else{
      destroyAlert();
    }
  }
 
  const retryButtonClick=()=>{
    buttonClicked();     
  }

  const errorViewDes = (desc)
    ? (
      <HighlightTextWithLogic
        textToHighlight={desc}
        searchWords={searchWords}
        textstyle={styles.hightlightMessage}
        highlightstyle={styles.textMessageUnderline}
        destroyAlert={destroyAlert}
      />
    ) : null;
    const retryButtonText = (isRetryEnabled)
    ? (
      <div style={styles.optionCointainer}>
      <TextLink
        style={styles.retryTouchableOpacityContainer}
        onClick={() => retryButtonClick()}
      >
        <div style={styles.retryContainer}>
          {yesButton? 
          <span style={styles.textMessageUnderline}>{t("Yes")}</span>
          :
          <>
            {/* <span style={styles.textMessageUnderline}>click</span> */}
            <span style={styles.textMessageUnderline}>{t("Retry")}</span>
          </>
          }
        </div>
      </TextLink>
      {noButton && 
        <TextLink
          style={styles.retryNo}
          onClick={handleClick}
        >
          <div style={styles.retryContainer}>
            <span style={styles.textMessageUnderline}>{t("No")}</span>
          </div>
        </TextLink>
      }
      </div>
    ) : null;
 return(
    <>
    { 
      title && text && type ?
        <Error>
          <h2><span>{title}</span></h2>
          <p>{text}</p>
          {errorViewDes}
          {retryButtonText}
          <ErrorClose onClick={handleClick} href="/"/>
        </Error>
        : <></>
      }
    </>
    )   
};

export default AlertPopup;

//Props details:

// open=true
// errorTitle="We had trouble logging you in"
// errorMessage="It took too long for us to process your log in request. Please try again soon (Error code 220)"
// setIsErrorOccured={setIsErrorOccured}
